export default "__VITE_ASSET__C7tuC8A0__"